module.exports = __webpack_public_path__ + "img/E_WEB_08.6d678190.png";